import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export const Pagination = ({ page, totalPages, total, pageSize, onPageChange }) => {
  if (totalPages <= 1) return null;

  const pages = [];
  const maxVisible = 5;
  let start = Math.max(1, page - Math.floor(maxVisible / 2));
  let end = Math.min(totalPages, start + maxVisible - 1);
  if (end - start < maxVisible - 1) {
    start = Math.max(1, end - maxVisible + 1);
  }

  for (let i = start; i <= end; i++) {
    pages.push(i);
  }

  const from = (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);

  return (
    <div className="flex items-center justify-between mt-6" data-testid="pagination">
      <p className="text-sm text-slate-400">
        {from}-{to} sur {total} résultats
      </p>
      <div className="flex items-center gap-1">
        <button
          onClick={() => onPageChange(page - 1)}
          disabled={page <= 1}
          className="p-2 rounded-md text-slate-400 hover:bg-[#F1F3F5] disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
          data-testid="pagination-prev"
        >
          <ChevronLeft size={18} />
        </button>
        {start > 1 && (
          <>
            <button
              onClick={() => onPageChange(1)}
              className="w-9 h-9 rounded-md text-sm text-slate-300 hover:bg-[#F1F3F5] transition-colors"
            >
              1
            </button>
            {start > 2 && <span className="px-1 text-slate-400">...</span>}
          </>
        )}
        {pages.map((p) => (
          <button
            key={p}
            onClick={() => onPageChange(p)}
            className={`w-9 h-9 rounded-md text-sm font-medium transition-colors ${
              p === page
                ? 'bg-[#0B132B] text-white'
                : 'text-slate-300 hover:bg-[#F1F3F5]'
            }`}
            data-testid={`pagination-page-${p}`}
          >
            {p}
          </button>
        ))}
        {end < totalPages && (
          <>
            {end < totalPages - 1 && <span className="px-1 text-slate-400">...</span>}
            <button
              onClick={() => onPageChange(totalPages)}
              className="w-9 h-9 rounded-md text-sm text-slate-300 hover:bg-[#F1F3F5] transition-colors"
            >
              {totalPages}
            </button>
          </>
        )}
        <button
          onClick={() => onPageChange(page + 1)}
          disabled={page >= totalPages}
          className="p-2 rounded-md text-slate-400 hover:bg-[#F1F3F5] disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
          data-testid="pagination-next"
        >
          <ChevronRight size={18} />
        </button>
      </div>
    </div>
  );
};
